import React from "react";
import { Modal, Paper, Typography, Box, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import EuroIcon from '@mui/icons-material/Euro';
import DefaultButton from "./DefaultButton";
import { useTheme } from "@mui/material/styles";

const introMessage = {
    en: {
        3: "Welcome to DUSHA",
        1: "First three rows of umbrellas: 50 € per umbrella.",
        2: "Fourth, fifth and sixth rows of umbrellas: 30 € per umbrella. Remaining rows: 20 € per umbrella",
        4: "Deposit Info",
        5: "You can order snacks and drinks from the BEACH menu for this amount. Bringing your own drinks and food to the “DUSHA” beach is strictly prohibited.",
        6: "Welcome to DUSHA - the finest beach bar and restaurant in Nea Kallikratia. Enjoy paradise on earth!"
    },
    ua: {
        3: "Ласкаво просимо до DUSHA",
        1: "Перші три ряди парасольок: 50 € за парасольку.",
        2: "Четвертий, п'ятий і шостий ряд парасольок: 30 € за парасольку. Решта рядів: 20 € за парасольку",
        4: "Інформація про депозит",
        5: "За цю суму ви можете замовити закуски та напої з меню BEACH. На пляж “DUSHA” суворо заборонено приносити свої напої та їжу." ,
        6: "Ласкаво просимо до DUSHA - найкращий пляжний бар і ресторан у Неа Каллікратії. Насолоджуйтесь раєм на землі!"
    },
    gr: {
        3: "Willkommen bei DUSHA",
        1: "Οι πρώτες τρεις σειρές ομπρελών: 50 € ανά ομπρέλα.",
        2: "Τέταρτη, πέμπτη και έκτη σειρά ομπρελών: 30 € ανά ομπρέλα. Υπόλοιπες σειρές: 20 € ανά ομπρέλα",
        4: "Informationen zur Anzahlung",
        5: "Für diesen Betrag können Sie Snacks und Getränke aus dem BEACH-Menü bestellen.Das Mitbringen eigener Getränke und Speisen an den Strand „DUSHA“ ist strengstens verboten.",
        6: "Willkommen bei DUSHA - der besten Strandbar und Restaurant in Nea Kallikratia. Genießen Sie das Paradies auf Erden!"
    },
    el: {
        3: "Καλώς ήρθατε στο DUSHA",
        1: "Οι πρώτες τρεις σειρές ομπρελών: 50 € ανά ομπρέλα.",
        2: "Τέταρτη, πέμπτη και έκτη σειρά ομπρελών: 30 € ανά ομπρέλα. Υπόλοιπες σειρές: 20 € ανά ομπρέλα",
        4: "Πληροφορίες προκαταβολής",
        5: "Μπορείτε να παραγγείλετε σνακ και ποτά από το μενού BEACH για αυτό το ποσό. Απαγορεύεται αυστηρά η κατανάλωση δικών σας ποτών και φαγητών στην παραλία “DUSHA”.",
        6: "Καλώς ήρθατε στο DUSHA - το καλύτερο beach bar και εστιατόριο στη Νέα Καλλικράτεια. Απολαύστε τον παράδεισο στη γη!"
    },
    se: {
        3: "Dobrodošli u DUSHA",
        1: "Први три реда сунцобрана: 50 € по сунцобрану.",
        2: "Четврти, пети и шести ред сунцобрана: 30 € по сунцобрану. Остали редови: 20 € по сунцобрану",
        4: "Informacije o depozitu",
        5: "Za ovaj iznos možete naručiti grickalice i pića iz BEACH menija. Strogo je zabranjeno unošenje sopstvenih pića i hrane na plažu “DUSHA”.",
        6: "Dobrodošli u DUSHA - najbolji beach bar i restoran u Nea Kallikratiji. Uživajte u raju na zemlji!"
    },
    ru: {
        3: "Добро пожаловать в DUSHA",
        1: "Первые три ряда зонтиков:  50 € за зонтик.",
        2: "Четвертый, пятый и шестой ряд зонтиков:  30 € за зонтик. Остальные ряды: 20 € за зонтик",
        4: "Информация о депозите",
        5: "На эту сумму вы можете заказать закуски и напитки из BEACH меню. На пляже “DUSHA” строго запрещается приносить свои напитки и продукты питания.",
        6: "Добро пожаловать в DUSHA - лучший пляжный бар и ресторан в Неа-Калликратии. Насладитесь раем на земле!"
    },
    uk: {
        3: "Ласкаво просимо до DUSHA",
        1: "Перші три ряди парасольок: 50 € за парасольку.",
        2: "Четвертий, п'ятий і шостий ряд парасольок: 30 € за парасольку. Решта рядів: 20 € за парасольку",
        4: "Інформація про завдаток",
        5: "На цю суму ви можете замовити закуски та напої з меню BEACH. На пляж “DUSHA” суворо заборонено приносити свої напої та їжу.",
        6: "Ласкаво просимо до DUSHA - найкращого пляжного бару та ресторану в Неа-Каллікратії. Насолоджуйтесь раєм на землі!"
    },
    de: {
         3: "Willkommen bei DUSHA",
         1: "Erste drei Reihen Sonnenschirme: 50 € pro Sonnenschirm.",
        2: "Vierte, fünfte und sechste Reihe Sonnenschirme: 30 € pro Sonnenschirm. Übrige Reihen: 20 € pro Sonnenschirm",
        4: "Einzahlungsinformationen",
        5: "Für diesen Betrag können Sie Snacks und Getränke aus dem BEACH-Menü bestellen. Das Mitbringen eigener Getränke und Speisen an den Strand „DUSHA“ ist strengstens verboten.",
        6: "Willkommen bei DUSHA - der beste Strandbar und das beste Restaurant in Nea Kallikratia. Genießen Sie das Paradies auf Erden!"
    }
}

const IntroModal = ({ onClose, open, lang }) => {
  const theme = useTheme();
  const messages = introMessage[lang];

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "center" }}
    >
      <Paper
        sx={{
          backgroundColor: theme.palette.primary.green,
          color: theme.palette.text.primary,
          padding: 3,
          borderRadius: 2,
          textAlign: "center",
          boxShadow: theme.shadows[5],
          maxWidth: 500,
          margin: "0 auto"
        }}
      >
        <Typography variant="h1" component="h2" color="white" sx={{ fontWeight: "bold", mb: 2 }}>
          {messages[3]}
              </Typography>
         
        <Typography variant="h5" component="h2" color="white" sx={{ fontWeight: "bold", textTransform: "uppercase" }}>
          {messages[4]+ ":"}
        </Typography>
        <List sx={{ pl: 1 }}>
          {[1, 2].map(key => (
            <ListItem key={key} disableGutters>
              <ListItemIcon>
                <EuroIcon sx={{ color: "white" }} />
              </ListItemIcon>
              <ListItemText
                primary={messages[key]+"*"}
                primaryTypographyProps={{ variant: "h5", color: "white" }}
              />
            </ListItem>
          ))}
              </List>
              <Typography variant="body1" component="h2" color="white" sx={{  mb: 2 }}>
          {"*" + " "+ messages[5]}
              </Typography>
              {/* <Typography variant="body1" component="h2" color="white" sx={{  mb: 2 }} >
          {"**" + " "+ messages[6]}
        </Typography> */}
        <DefaultButton
          visibility={true}
          onClick={onClose}
          label="Ok"
          relative={true}
        />
      </Paper>
    </Modal>
  );
};

export default IntroModal;
